export const TableDensity = {
  COMPACT: 'compact',
  DEFAULT: 'default',
  COMFORTABLE: 'comfortable'
} as const;
export type TableDensity = (typeof TableDensity)[keyof typeof TableDensity];

// Row height (also the default header height) per density; the matching font size and cell padding
// live in BPMTable.scss under `.density-*`.
const TABLE_DENSITY: Record<TableDensity, { rowHeight: number; className: string }> = {
  [TableDensity.COMPACT]: { rowHeight: 28, className: 'density-compact' },
  [TableDensity.DEFAULT]: { rowHeight: 40, className: 'density-default' },
  [TableDensity.COMFORTABLE]: { rowHeight: 52, className: 'density-comfortable' }
};

const LEGACY_ROW_HEIGHT = 50;

export const getDensityRowHeight = (density?: TableDensity): number =>
  density ? TABLE_DENSITY[density].rowHeight : LEGACY_ROW_HEIGHT;

export const getDensityClassName = (density?: TableDensity): string | undefined =>
  density && TABLE_DENSITY[density].className;
